/* eslint-disable max-len, no-useless-escape */
const domainValidationRegex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/g
const emailValidationRegex = /^(?!.*\.\.)(?!.*--)(?!^[.-])(?=[^@]{1,64}@)(?<![-.])(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x21-\x5b\x5d-\x7e]|\\[\x21-\x7e])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[a-z]{2,}|[a-z0-9-]{2,}\.[a-z0-9-]{2,}))$/i
const topLevelDomainRegex = /@[\w]+\.([\w.]+)/
/* eslint-enable max-len, no-useless-escape */

export const socialMediaUrlPatterns = {
  linkedinUrl: /^(https?:\/\/)?((www|[a-z]{2})\.)?linkedin\.com\/.+$/i,
  twitterUrl: /^(https?:\/\/)?(www\.)?(twitter|x)\.com\/.+$/i,
  facebookUrl: /^(https?:\/\/)?(www\.)?facebook\.com\/.+$/i,
  xingUrl: /^(https?:\/\/)?(www\.)?xing\.com\/.+$/i,
  threadsUrl: /^(https?:\/\/)?(www\.)?threads\.(net|com)\/@.+$/i,
  tiktokUrl: /^(https?:\/\/)?(www\.)?tiktok\.com\/@.+$/i,
  instagramUrl: /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i,
  youtubeUrl: /^(https?:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i,
  otherUrl: /^(https?:\/\/)?(www\.)?[^.]+\.[^.]+.+$/i
}

export const validDomain = domain => (domain && !!domain.match(domainValidationRegex))
export const validEmail = email => {
  if (typeof email !== 'string' || email.trim() === '') {
    return false
  }

  const [localPart, domainPart, ...rest] = email.split('@')

  if (!localPart || !domainPart || rest.length > 0) {
    return false
  }

  if (localPart.endsWith('-') || localPart.endsWith('.')) {
    return false
  }

  return (email && !!email.match(emailValidationRegex))
}
export const getTopLevelDomain = email => topLevelDomainRegex.test(email) && topLevelDomainRegex.exec(email)[1]

export const validateName = string => {
  // Unicode letter characters only, but allow also for names with accents
  // and other diacritics and the minus character and the space character
  // and punctuation marks like comma and dot
  const re = /^[\p{L}\p{M}\s\-,.']+$/u

  return re.test(String(string))
}

export const validatePhoneNumber = string => {
  // Allow digits, spaces, plus, minus, parentheses, dots, and slashes
  const re = /^[0-9\s+\-()./]+$/

  return re.test(String(string))
}

export const validateWebsite = string => {
  // Basic validation for website URLs
  const re = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-._~:/?#%[\]@!$&'()*+,;=]*)?$/

  return re.test(String(string))
}

export const validateEmail = email => validEmail(email)

export const validateSocialMediaUrl = (channel, url) => {
  const pattern = socialMediaUrlPatterns[channel]

  if (!pattern) {
    return false
  }

  return pattern.test(String(url))
}

export const ensureHttpsPrefix = url => {
  if (typeof url !== 'string' || url.trim() === '') {
    return url
  }

  if (/^https?:\/\//i.test(url)) {
    return url.replace(/^http:\/\//i, 'https://')
  }

  return `https://${url}`
}
